/**
 * LaunchDarkly flag keys (must match dashboard keys).
 * @see https://docs.launchdarkly.com/sdk/client-side/react/react-web#using-useflags
 */
export const FEAT_ANTIVIRUS_CHECK_IN_FILE_UPLOAD =
  'featAntivirusCheckInFileUpload';

export const isAntivirusFileScanEnabled = (flags) =>
  flags?.[FEAT_ANTIVIRUS_CHECK_IN_FILE_UPLOAD] === true;
